import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {WorkforceProfileWizardExperienceEditor} from '../WorkforceProfileWizardExperienceEditor';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import type {WorkforceProfileExtractedWorkExperience} from '../../../types/workforceProfileDetailsTypes';

export interface Props {
  workExperiences: WorkforceProfileExtractedWorkExperience[];
  onWorkExperiencesChange: (rows: WorkforceProfileExtractedWorkExperience[]) => void;
}

export const WorkforceProfileWizardExperienceStep = ({workExperiences, onWorkExperiencesChange}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.experience'});

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <WorkforceProfileWizardExperienceEditor rows={workExperiences} onChange={onWorkExperiencesChange} />
    </Box>
  );
};
